/**
 * @fileoverview POST handler for the "/alloys/gemini/agentic/:app_group_id/oauth/select_project" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysGeminiAgenticOauthSelectProjectCacheKeys } from "./constants";
import type {
  PostAlloysGeminiAgenticOauthSelectProjectProps,
  PostAlloysGeminiAgenticOauthSelectProjectResult,
} from "./types";

export const postAlloysGeminiAgenticAppGroupIdOauthSelectProject = reactQueryMutationAdapter(
  postAlloysGeminiAgenticOauthSelectProjectCacheKeys,
  (
    props: PostAlloysGeminiAgenticOauthSelectProjectProps
  ): Promise<PostAlloysGeminiAgenticOauthSelectProjectResult> => {
    return fetch(
      `/alloys/gemini/agentic/${props.appGroupId}/oauth/select_project`,
      "POST",
      { project_id: props.projectId, project_name: props.projectName, use_vertex_ai: props.useVertexAi },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
